import React from 'react';
import Dashboard from './Dashboard';
import SignOutButton from './SignOutButton';

const DeleteReservations = () => (
  <div className="wrapper">
    <Dashboard />
    <SignOutButton />
  </div>
);

export default DeleteReservations;
